export default __webpack_public_path__ + "static/Artboard-9-194c4cd410c6e72fb4626b51d60e9ce1.webp";